module.exports = {
  _id: {},
  client: { pl: 'Klient', width: '400', source: 'companies', type: 'select' },
  department: { pl: 'Dział', width: '400', source: 'departments', type: 'select' },
  hcva: { pl: 'Hcva', width: '150', type: 'input', editable: true },
  hidden: { pl: 'Ukryte', width: '150', type: 'checkbox', editable: true }
}
